var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialTiktok = function SvgSocialTiktok(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9076 12.9928C9.96726 12.8139 9.15726 12.8461 8.32101 13.3438C6.25273 14.5737 6.29163 17.5839 8.40074 18.758C10.3873 19.8638 12.8037 18.5713 13.0439 16.3364L13.039 1.25502C13.0371 1.06144 13.1995 1.04971 13.3551 1.03602C13.9463 0.983228 14.9926 0.993005 15.5916 1.03602C15.6723 1.04189 15.751 1.04678 15.8259 1.08197C16.3277 3.48799 18.4134 5.44233 20.9212 5.42571C20.9417 5.43157 21 5.58604 21 5.59973V9.94249C21 10.0843 20.2795 9.92685 20.1657 9.90338C18.9842 9.66288 17.8718 9.11832 16.8771 8.45449V16.3823C16.5698 21.5668 11.0029 24.665 6.4793 22.0576C3.0526 20.0847 1.95769 15.6843 4.095 12.3143C5.55261 10.0158 8.19946 8.77614 10.9076 9.18774V12.9928Z",
    fill: "#363645"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialTiktok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-tiktok.291dbe2fcf3c6f554decf330fdb34b76.svg";